import React from 'react';
import PropTypes from 'prop-types';
import Toggle from '../../../common/components/Toggle/Toggle';

export function RoleStatusToggle({ onToggle, roleId, toggled }) {
  const handleToggle = (e, checked) => {
    onToggle(roleId, checked);
  };

  return <Toggle toggled={toggled} onToggle={handleToggle} />;
}

RoleStatusToggle.propTypes = {
  roleId: PropTypes.string.isRequired,
  toggled: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
};
